import { useTranslation } from 'react-i18next'
import { LmsUserProfile } from '@rankmi/lms-components'
import '@rankmi/lms-components/dist/index.css'
import { translations } from './translations'

interface IProps {
  userId: number
}

export const UserProfile = ({ userId }: IProps) => {
  const { t } = useTranslation()

  return (
    <LmsUserProfile
      locale={translations(t)}
      userId={userId}
      padding="25px 49px"
    />
  )
}

export default UserProfile
